import {injectable, decorate} from 'inversify';
import {ILocationService} from './ILocationService';

export class LocationService implements ILocationService {
  setHref(href: string) {
    location.href = href;
  }

  getHash() {
    return location.hash;
  }

  getSearch() {
    return location.search;
  }
}

decorate(injectable(), LocationService);
